import { SelectField } from "$components/rhf-fields";
import { useMaritalStatusTranslation } from "$routes/new/_lib/use-marital-status-translation";
import React from "react";
import { useIntl } from "react-intl";

export const MaritalStatusSelectInput: FC<
  {
    name: string;
  } & Omit<React.ComponentProps<typeof SelectField>, "options">
> = ({ name, ...delegateProps }) => {
  const { formatMessage } = useIntl();
  const { maritalStatuses } = useMaritalStatusTranslation();

  return (
    <SelectField
      name={name}
      data-testid="patientRegistrationMaritalStatus"
      label={formatMessage({
        id: "patient.additionalInfo.maritalStatusSelect.label",
        defaultMessage: "Marital Status",
      })}
      options={maritalStatuses.map(({ name, code }) => ({
        label: name,
        value: code,
      }))}
      {...delegateProps}
    />
  );
};
